var o = {};
export {
  o as __exports
};
//# sourceMappingURL=index.es442.js.map
